import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, NavigationEnd, Router} from '@angular/router';
import {BehaviorSubject} from 'rxjs';
import {filter} from 'rxjs/operators';
import {MenuItem} from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {
  private breadcrumbsSubject = new BehaviorSubject<MenuItem[]>([]);
  breadcrumbs$ = this.breadcrumbsSubject.asObservable();

  constructor(private router: Router) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        const root = this.router.routerState.snapshot.root;
        const breadcrumbs = this.buildBreadcrumbs(root);
        this.breadcrumbsSubject.next(breadcrumbs);
      });
  }

  private buildBreadcrumbs(
    route: ActivatedRouteSnapshot,
    url: string = '',
    breadcrumbs: MenuItem[] = []
  ): MenuItem[] {
    const routeUrl = route.url.map(segment => segment.path).join('/');
    const nextUrl = routeUrl ? `${url}/${routeUrl}` : url;

    const breadcrumb = route.data['breadcrumb'];

    if (breadcrumb && routeUrl !== '') {
      breadcrumbs.push({
        label: typeof breadcrumb === 'function'
          ? breadcrumb(route.data)
          : breadcrumb,
        routerLink: nextUrl
      });
    }

    if (route.firstChild) {
      return this.buildBreadcrumbs(route.firstChild, nextUrl, breadcrumbs);
    }

    return breadcrumbs;
  }

  updateLastBreadcrumbLabel(newLabel: string) {
    const currentBreadcrumbs = this.breadcrumbsSubject.getValue();

    if (currentBreadcrumbs.length > 0) {
      const updatedBreadcrumbs = [...currentBreadcrumbs];
      const lastIndex = updatedBreadcrumbs.length - 1;

      updatedBreadcrumbs[lastIndex] = {
        ...updatedBreadcrumbs[lastIndex],
        label: newLabel
      };

      this.breadcrumbsSubject.next(updatedBreadcrumbs);
    }
  }
}
